import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { MultiSelect } from "react-multi-select-component";
const Emails = (props) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [item, setItem] = useState({
    contact_us: "",
    request: "",
    note: "",
    comment: "",
  });
  const handleChangeContactUs = (newValue) => {
    setItem({ ...item, contact_us: newValue });
    setContactError("");
  };
  const [contactError, setContactError] = useState("");
  const handleChangeRequest = (newValue) => {
    setItem({ ...item, request: newValue });
    setRequestError("");
  };
  const [requestError, setRequestError] = useState("");
  const handleChangeNote = (newValue) => {
    setItem({ ...item, note: newValue });
    setNoteError("");
  };
  const [noteError, setNoteError] = useState("");
  const handleChangeComment = (newValue) => {
    setItem({ ...item, comment: newValue });
    setCommentError("");
  };
  const [commentError, setCommentError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [error, setError] = useState("");
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  useEffect(() => {
    axios
      .get(`/form-emails`)
      .then((result) => {
        setItem({
          contact_us:
            result?.data?.data?.contact_us_email &&
            result?.data?.data?.contact_us_email[0]
              ? result.data.data.contact_us_email[0]
              : "",
          request:
            result?.data?.data?.request_email &&
            result.data.data.request_email[0]
              ? result.data.data.request_email[0]
              : "",
          note:
            result?.data?.data?.note_email && result.data.data.note_email[0]
              ? result.data.data.note_email[0]
              : "",
          comment:
            result?.data?.data?.comment_email &&
            result.data.data.comment_email[0]
              ? result.data.data.comment_email[0]
              : "",
        });
        setIsSaving(false);
      })

      .catch((err) => console.log(err));
  }, []);

  return (
    <Page title={`Emails`} narrowWidth>
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <TextField
            label="Contact Us Email"
            value={item.contact_us}
            onChange={handleChangeContactUs}
            error={contactError}
          />
          <TextField
            label="Request Email"
            value={item.request}
            onChange={handleChangeRequest}
            error={requestError}
          />
          <TextField
            label="Note Email"
            value={item.note}
            onChange={handleChangeNote}
            error={noteError}
          />
          <TextField
            label="Comment Email"
            value={item.comment}
            onChange={handleChangeComment}
            error={commentError}
          />
          <InlineError message={error} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
      />
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (
      (item.contact_us && !isValidEmail(item.contact_us)) ||
      (item.request && !isValidEmail(item.request)) ||
      (item.note && !isValidEmail(item.note)) ||
      (item.comment && !isValidEmail(item.comment))
    ) {
      item.contact_us &&
        !isValidEmail(item.contact_us) &&
        setContactError("Please enter a valid email");
      item.request &&
        !isValidEmail(item.request) &&
        setRequestError("Please enter a valid email");
      item.note &&
        !isValidEmail(item.note) &&
        setNoteError("Please enter a valid email");
      item.note &&
        !isValidEmail(item.note) &&
        setCommentError("Please enter a valid email");
    } else {
      setIsSaving(true);
      axios
        .post(`/form-emails`, {
          contact_us_email: [item.contact_us],
          request_email: [item.request],
          note_email: [item.note],
          comment_email: [item.comment],
        })
        .then((result) => {
          setIsSaving(false);
          toggleActive();
        })

        .catch((error) => {
          setIsSaving(false);
          console.log(error.config);
        });
    }
  }
};

export default Emails;
